module.exports = __webpack_public_path__ + "static/media/blur2.62d311b1.png";